// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__8rYqp","projectItem":"styles_projectItem__Ms8RI","showMore":"styles_showMore__ti+5k","skeleton":"styles_skeleton__wbum8"};